import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Collapse } from 'react-bootstrap';
import { connect } from "react-redux";

/* UTILS/ HELPERS */
import { DEFAULT_CREDIT_CARD } from '../../../../constants/paymentMethods';
import {
  getCloudImageUrl,
  convertToRupiah,
  formatCurrency,
} from '../../../../utils';

/* INTERFACES */
import {
  size,
  balanceUsage,
  paymentMethods,
  addOnProduct,
} from '../../Interfaces';

/* ASSETS */
import CircleBack from '../../../../images/circle-back.png';
import ArrowsNext from '../../../../images/arrowsNext.png';
import ArrowDown from '../../../../images/arrowDown.png';

/* COMPONENTS */
import PaymentSummary from '../PaymentSummary';
import AmountTobePaid from './AmountTobePaid';
import PaymentTypeWrapper from './PaymentTypeWrapper';

const CircleBackIcon: any = CircleBack;
const ArrowsNextIcon: any = ArrowsNext;
const ArrowDownIcon: any = ArrowDown;

type ChoosePaymentsProps = {
  etaText: string;
  size: size;
  total: any;
  voucherEnabledPayments: any;
  userCurrency: any;
  dataUserCurrency: any;
  isResponsive: boolean;
  subsidy_price: number;
  balance: string;
  asking_price: string;
  buyNowPrice: string;
  admin_fee: number;
  discount: number;
  shipping_fee: number;
  totalAddOnProduct: number;
  emptyImage: any;
  display_name: string;
  dataAkulaku: Array<Object>;
  totalBalance: number;
  shippingCountry: string;
  isIndonesian: boolean;
  productCondition: string;
  balanceUsage: balanceUsage;
  amountToBePaid: number;
  productImage: string;
  creditDebitOnly: boolean;
  isCashback: boolean;
  balance_with_fee: string;
  locked_balance: string;
  availableMethods: Array<paymentMethods>;
  _installmentsList: Array<Object>;
  filteredAddOnProduct: Array<addOnProduct>;
  setIsSplitPayment: (params: boolean) => void;
  setCheckoutProcess: (string: string) => void;
  handleSetAtomePrice: () => void;
  setCurrentPaymentMethod: (item: Object) => void;
  handleFetchKredivoInstallments: (params: number) => void;
};

const ChoosePayments: React.FC<ChoosePaymentsProps> = ({
  size,
  subsidy_price,
  etaText,
  discount,
  admin_fee,
  shipping_fee,
  balance,
  asking_price,
  buyNowPrice,
  emptyImage,
  totalAddOnProduct,
  dataAkulaku,
  balanceUsage,
  shippingCountry,
  isIndonesian,
  totalBalance,
  amountToBePaid,
  creditDebitOnly,
  productCondition,
  availableMethods,
  balance_with_fee,
  display_name,
  _installmentsList,
  filteredAddOnProduct,
  locked_balance,
  setIsSplitPayment,
  setCheckoutProcess,
  handleSetAtomePrice,
  setCurrentPaymentMethod,
  handleFetchKredivoInstallments,
  productImage,
  isResponsive,
  userCurrency,
  total,
  isCashback,
  voucherEnabledPayments,
  dataUserCurrency //user currency from redux
}): JSX.Element => {
  const [openCollapse, setOpenCollapse] = useState(false);
  const [isShowDescOnSummaryAddOn, setIsShowDescOnSummaryAddOn] = useState(
    null,
  );
  const shipToIndonesia = shippingCountry === 'IDN'

  const availableCreditCardPayments = () => {
    let payments = availableMethods.filter((item) => item.payment_group === 1 && item.type === 'credit_card')

    if (!isIndonesian || !shipToIndonesia) {
      payments = payments.filter(item => item.payment_method === DEFAULT_CREDIT_CARD && item.label !== 'BCA Card')
    }

    return payments
  }

  const handleShowDescriptionOnSummaryAddon = (args) => {
    if (args === isShowDescOnSummaryAddOn) {
      setIsShowDescOnSummaryAddOn(null);
    } else {
      setIsShowDescOnSummaryAddOn(args);
    }
  }

  return (
    <div id="choose-payment-wrapper">
      <div className="payment-list-scroll">
        <div className="header-container">
          <div className="icon-wrapper" onClick={() => setCheckoutProcess('')}>
            <KickImage src={CircleBackIcon} alt="..." />
          </div>
          <div className="text">
            <p>Choose Payment</p>
          </div>
        </div>
        {isResponsive && (
          <AmountTobePaid
            fn={() => isResponsive && setOpenCollapse(!openCollapse)}
            amountToBePaid={convertToRupiah(amountToBePaid)}
            userCurrency={userCurrency}
          >
            {isResponsive && (
              <div className="show-sum-icon-wrapper">
                <KickImage src={ArrowDownIcon} alt="..." />
              </div>
            )}
          </AmountTobePaid>
        )}
        {isResponsive && (
          <Collapse in={openCollapse}>
            <div className="collapse-wrapper">
              <h3>Order Details</h3>

              {/* PRODUCT CARD + ADDON SELECTED */}
              <div className="responsive-checkout-product-container">
                {/* MAIN PRODUCT ITEM */}
                <div className="checkout-item-card">
                  <div className="main-item-image-wrapper">
                    {productImage ? (
                      <KickImage
                        src={getCloudImageUrl(productImage, 500)}
                        alt="..."
                      />
                    ) : (
                      <KickImage src={emptyImage} alt="..." />
                    )}
                  </div>
                  <div className="main-item-description-wrapper">
                    <div className="name-n-condition">
                      <p>{display_name}</p>
                      <p>
                        {size.US} / {productCondition} / {etaText}{' '}
                      </p>
                    </div>
                    <div className="price-container">
                      <p>{formatCurrency(parseInt(asking_price), userCurrency.ratio, userCurrency.currency)}</p>
                    </div>
                  </div>
                </div>

                {/* ADD ONS ITEM */}
                {filteredAddOnProduct.length > 0 &&
                  filteredAddOnProduct
                    .filter((item) => item.isSelected)
                    .map((item, index) => {
                      const { img_url, displayName, description, price } = item;
                      const removeBrDescription = (() => {
                        const splitted = description
                          ? description.split('<br>')
                          : [];
                        return splitted[1]
                          ? `${splitted[0]}${splitted[1]}`
                          : description;
                      })();
                      return (
                        <div className="addon-item-wrapper">
                          <div className="addon-item-card-image-wrapper">
                            {img_url ? <KickImage src={img_url} alt="..." /> : null}
                          </div>
                          <div
                            className="addon-description-wrapper"
                            onClick={() =>
                              handleShowDescriptionOnSummaryAddon(index)
                            }
                          >
                            <div className="name-n-desc">
                              <p>{displayName}</p>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: removeBrDescription,
                                }}
                                className={`description-text ${
                                  removeBrDescription ? '' : 'remove-after'
                                } ${
                                  isShowDescOnSummaryAddOn === index
                                    ? 'show'
                                    : ''
                                }`}
                              />
                            </div>
                            <div className="price-container">
                              <p>{formatCurrency(parseInt(price), userCurrency.ratio, userCurrency.currency)}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
              </div>

              {/* PAYMENT SUMMARY */}
              <div className="payment-summary-container">
                <PaymentSummary
                  asking_price={parseInt(asking_price)}
                  admin_fee={admin_fee}
                  shipping_fee={shipping_fee}
                  discount={discount}
                  totalAddOnProduct={totalAddOnProduct}
                  subsidy_price={subsidy_price}
                  amountToBePaid={convertToRupiah(total)}
                  isCashback={isCashback}
                  userCurrency={userCurrency}
                />
              </div>
            </div>
          </Collapse>
        )}

        {isResponsive && (
          <div className="top-box-shadow">
            <p></p>
          </div>
        )}

        {/* RENDER KICK CREDIT */}
        {
          isIndonesian && shipToIndonesia && 
            <PaymentTypeWrapper
            type="Kick Credit"
            additionalWrapperClass="kick-credit"
            description="Your payment will be verified automatically by the payment gateway."
            addtional_class_for_card="kick-wallet-text"
            disabled={(!isIndonesian && !shipToIndonesia) || (totalBalance > 0 || !creditDebitOnly ? false : true) || (voucherEnabledPayments ? voucherEnabledPayments?.length > 0 ? !voucherEnabledPayments.includes("full_wallet") : true : false)}
            payment_methods={availableMethods.filter(
              (item) => item.payment_group === 3,
            )}
            choosePaymentHandler={(item) => {
              setCheckoutProcess('confirm-kick-credit');
              setCurrentPaymentMethod(item);
              setIsSplitPayment(totalBalance < amountToBePaid ? true : false);
              handleFetchKredivoInstallments(balanceUsage.remainingPayment);
            }}
          >
            <p>
              Credit Balance:{' '}
              <span>
                {formatCurrency(
                  parseInt(balance) + parseInt(balance_with_fee),
                  dataUserCurrency.ratio,
                  dataUserCurrency.currency,
                )}
              </span>
            </p>
            <p>
              Kick Points:{' '}
              <span>
                {formatCurrency(
                  parseInt(locked_balance),
                  userCurrency.ratio,
                  "KP",
                )}
              </span>
            </p>
          </PaymentTypeWrapper>
        }

        {/* RENDER CREDIT-CARD */}
        <PaymentTypeWrapper
          type="Credit Card"
          description="Your payment will be verified automatically by the payment gateway."
          addtional_class_for_card=""
          payment_methods={availableCreditCardPayments()
            .map((item) => {
              const voucherDisabled = (voucherEnabledPayments ? voucherEnabledPayments?.length > 0 ? !voucherEnabledPayments.includes(item.payment_method) : true : false)
              const disabled = (item.active && (isIndonesian && shipToIndonesia) && !voucherDisabled) ||
                  ((!isIndonesian || !shipToIndonesia) && item.payment_method === DEFAULT_CREDIT_CARD)
                  ? false
                  : true;
              return {
                ...item,
                disabled,
              };
            })}
          choosePaymentHandler={(item) => {
            setCheckoutProcess('confirm-others-kick-credit');
            setCurrentPaymentMethod(item);
          }}
        />

        {/* RENDER VIRTUAL ACCOUNTS */}
        {isIndonesian && shipToIndonesia && 
          <PaymentTypeWrapper
            type="Virtual Acccount"
            description="Your payment will be verified automatically by the payment gateway."
            addtional_class_for_card=""
            payment_methods={availableMethods
              .filter(
                (item) =>
                  item.payment_group === 1 && item.type === 'virtual_account',
              )
              .map((item) => {
                const voucherDisabled = (voucherEnabledPayments ? voucherEnabledPayments?.length > 0 ? !voucherEnabledPayments.includes(item.payment_method) : true : false)
                const disabled = item.active && (isIndonesian && shipToIndonesia) && !voucherDisabled ? false : true;
                return {
                  ...item,
                  disabled,
                };
              })}
            choosePaymentHandler={(item) => {
              setCheckoutProcess('confirm-others-kick-credit');
              setCurrentPaymentMethod(item);
            }}
          />
        }

        {/* BANK TRANSFER */}
        {/* {isIndonesian && shipToIndonesia && 
          <PaymentTypeWrapper
            type="Bank Transfer - Manual Verification"
            description="Please allow 1 working day for us to verify your payment."
            addtional_class_for_card=""
            payment_methods={availableMethods
              .filter(
                (item) =>
                  item.payment_group === 1 && item.type === 'bank_transfer',
              )
              .map((item) => {
                const voucherDisabled = (voucherEnabledPayments ? voucherEnabledPayments?.length > 0 ? !voucherEnabledPayments.includes(item.payment_method) : true : false)
                const disabled = item.active && (isIndonesian && shipToIndonesia) && !voucherDisabled ? false : true;
                return {
                  ...item,
                  disabled,
                };
              })}
            choosePaymentHandler={(item) => {
              setCheckoutProcess('confirm-others-kick-credit');
              setCurrentPaymentMethod(item);
            }}
          />
        } */}

        {/* INSTALLMENTS */}
        {isIndonesian && shipToIndonesia &&
          <PaymentTypeWrapper
            type="Non-CC Installment"
            description="Your payment will be verified automatically by the payment gateway."
            addtional_class_for_card=""
            payment_methods={availableMethods
              .filter((item) => item.payment_group === 2)
              .map((item) => {
                let disabled = false;
                const voucherDisabled = voucherEnabledPayments
                  ? voucherEnabledPayments?.length > 0
                    ? !voucherEnabledPayments.includes(item.payment_method)
                    : true
                  : false;

                switch (item.payment_method) {
                  case 'atome':
                    disabled = item.active && (isIndonesian && shipToIndonesia) && !voucherDisabled ? false : true;
                    break;
                  case 'kredivo':
                    const kredivoData =
                      _installmentsList.length && _installmentsList.length > 0;

                    disabled =
                      item.active && (isIndonesian && shipToIndonesia) && kredivoData && !voucherDisabled ? false : true;
                    break;
                  case 'akulaku':
                    const akulakuData =
                      dataAkulaku.length && dataAkulaku.length > 0;

                    disabled =
                      item.active && (isIndonesian && shipToIndonesia) && akulakuData && !voucherDisabled ? false : true;
                    break;
                }
                return {
                  ...item,
                  disabled,
                };
              })}
            choosePaymentHandler={(item) => {
              switch (item.payment_method) {
                case 'atome':
                  handleSetAtomePrice();
                  setCheckoutProcess('confirm-atome-payment');
                  setCurrentPaymentMethod(item);
                  break;
                case 'kredivo':
                  setCheckoutProcess('confirm-kredivo-payment');
                  setCurrentPaymentMethod(item);
                  break;
                case 'akulaku':
                  setCheckoutProcess('confirm-akulaku-payment');
                  setCurrentPaymentMethod(item);
              }
            }}
          />
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataUserCurrency: state.dataAuth.userCurrency
})

export default connect(mapStateToProps)(ChoosePayments);
